import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router';
import { useSession } from '../../common/authorization/context/Session';
import SelfServiceLayout from './SelfServiceLayout';
import { useSelfServiceData } from '../utils/useSelfServiceData';

export const SelfServiceContainer = () => {
  const { t } = useTranslation();
  document.title = t('self-service.browser-title');

  const { userInfo } = useSession();

  const { data } = useSelfServiceData();

  const logoUrl = data?.orgInfo?.logoUrl || '';
  const username = userInfo?.username || userInfo?.email || userInfo?.userUpn || '';
  const email = userInfo?.email || userInfo?.userUpn || '';

  return (
    <SelfServiceLayout logoUrl={logoUrl} username={username} email={email}>
      <Row>
        <Col span={24}>
          <Outlet />
        </Col>
      </Row>
    </SelfServiceLayout>
  );
};
